import {Component, HostListener, Input} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {urlDeIncorporacao, videoOnboarding, VideoOnboarding} from './onboarding-videos';
import {OnboardingPainelService} from '../onboarding-painel.service';

/** "Ver como faz · 0:40": abre o vídeo curto do passo por cima da tela. Nunca começa sozinho. */
@Component({
  selector: 'app-onb-video',
  template: `
    <button type="button" class="onb-video-btn" *ngIf="video" (click)="abra()">
      <i class="fas fa-play"></i> Ver como faz · {{ video.duracao }}
    </button>
    <div class="onb-video-veu" *ngIf="aberto" (click)="feche()">
      <div class="onb-video-folha" role="dialog" [attr.aria-label]="video?.titulo" (click)="$event.stopPropagation()">
        <div class="onb-video-topo">
          <b>{{ video?.titulo }}</b>
          <button type="button" (click)="feche()" aria-label="Fechar"><i class="fas fa-times"></i></button>
        </div>
        <div class="onb-video-player">
          <iframe [src]="url" title="{{ video?.titulo }}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./onb-video.component.scss']
})
export class OnbVideoComponent {
  video: VideoOnboarding | null = null;
  url: SafeResourceUrl | null = null;
  aberto = false;
  private id = '';

  constructor(private sanitizer: DomSanitizer, private onboarding: OnboardingPainelService) {}

  @Input() set passo(id: string) {
    this.id = id;
    this.video = videoOnboarding(id);
  }

  abra(): void {
    if (!this.video) return;
    const endereco = urlDeIncorporacao(this.video.url);
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`${endereco}${endereco.includes('?') ? '&' : '?'}autoplay=1`);
    this.aberto = true;
    this.onboarding.registre('VIDEO_ABERTO', this.id);
  }

  @HostListener('document:keydown.escape')
  feche(): void {
    this.aberto = false;
    this.url = null;
  }
}
